import React, { useEffect } from 'react';
import { Eventfeed2 } from '../controller/eventfeed2.js'
import { NavBarGuest, NavBarAffiliate, NavBarUser } from './NavBar';
import './css/AffiliateEvents.css'

export function AffiliateEventsView(props) {

  return (
    <div className="affiliatemore">
      {/*!stop_store_event && get_events()*/}
      {props.type_1 === "" ? <NavBarGuest /> : props.type_1 === "Student" ? <NavBarUser /> : <NavBarAffiliate />}


      <div className="backy">
        <button className="backybtn" onClick={props.history}>Back to Affiliate Page</button>
        <h1 className="backyevent">Events</h1>
      </div>
      {props.eventy.map(subs => (
        <div>
          <Eventfeed2 title={subs.title} description={subs.description} location={subs.location} start={subs.start} affiliate={subs.affiliate} picture={subs.pictures} check_affiliate={props.check_affiliate} end={subs.end} tags={subs.tags} inaffiliate_view={true} />
        </div>
      ))}
    </div>
  );
}